export default __webpack_public_path__ + "static/carlton-mg-logo-dark-c07bab90a8774ae3f87246c878969deb.png";